
import { Chart } from "chart.js";
import { TimeSeriesDataArray } from "../../interfaces/time-series-data";
import { time } from "../../services/global-variables.service";
import { el, enUS } from "date-fns/locale";
import { registerables } from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import 'chartjs-adapter-date-fns';

export class ChartJsHeating {
  graph: any;

  constructor() { }

  getBackgroundColour(elementName: string) {
    switch (elementName) {
      case "temperature":
        return "#0E8E75";
      case "targetTemperature":
        return "orange";
      case "valveLevel":
        return "#000080";
    }
  }

  public draw(data: TimeSeriesDataArray[], features) {
    Chart.register(...registerables);
    Chart.register(zoomPlugin);

    heatingDataProcess(data, features);

    let graphDataSets = [];

    for (let i = 0; i < features.length; i++) {
      let element = features[i];
      if (!element) {
        continue;
      }
      let dataSet = data[i];
      let processedData = [];

      for (let i in dataSet) {
        processedData.push({
          x: dataSet[i].timestamp,
          y: element.attributes.type === "temperature" || element.attributes.type === "targetTemperature" ? dataSet[i].value / 10 : dataSet[i].value
        })
      }
      let graphDataSet = {
        label: element.attributes.type,
        data: processedData,
        borderWidth: 1,
        pointRadius: 0,
        stepped: element.attributes.type === "targetTemperature" || element.attributes.type === "valveLevel" ? 'after' : false,
        yAxisID: element.attributes.type === "temperature" || element.attributes.type === "targetTemperature" ? "Temperature" : "ValveLevel",
        backgroundColor: this.getBackgroundColour(element.attributes.type),
        borderColor: this.getBackgroundColour(element.attributes.type),
      }
      graphDataSets.push(graphDataSet);
    }

    let scales: any = {
      Temperature: {
        type: 'linear',

        min: () => {

          let minTemperature = 100;

          for (let i in features) {
            if (features[i].attributes.type === "targetTemperature") {
              const featureData = data[i];
              for (let j in featureData) {
                const tempMin = featureData[j].value / 10;
                if (minTemperature > tempMin) {
                  minTemperature = tempMin;
                }
              }
            }
            if (features[i].attributes.type === "temperature") {
              const featureData = data[i];
              // Get minimum temperature
              for (let j in featureData) {
                const tempMin = featureData[j].value / 10;
                if (minTemperature > tempMin) {
                  minTemperature = tempMin;
                }
              }
            }
          }


          return minTemperature;
        },
        position: 'left',
      },
      x: {

        type: 'time',
        adapters: {
          date: {
            locale: enUS
          },

        },
        time: {
          unit: 'day',
        }
      },
    }

    for (let index in features) {
      if (features[index].attributes.type === "valveLevel") {
        scales["ValveLevel"] = {

          type: 'linear',
          max: 100,
          position: 'right',

          ticks: {
            callback: function (value, index, values) {
              if (index === values.length - 1) {
                return "";
              }

              return value + "%";
            }
          },
        }
        break;
      }
    }

    this.graph = new Chart("graph1", {
      type: "line",
      data: {
        datasets: graphDataSets,
      },
      options: {
        plugins: {
          zoom: {
            zoom: {
              drag: {
                enabled: true
              },
              mode: 'x',
            }
          },
        },
        scales: scales,
        maintainAspectRatio: false,

      }
    });
  }

}

export const heatingDataProcess = function (data, features) {
  for (let index = 0; index < features.length; index++) {
    if (!features[index]) {
      continue;
    }
    if (features[index].attributes.type === "windowPosition") {
      delete features[index];
      delete data[index];
      continue;
    }
    addLastValue(data[index]);
  }
};

export const compareFunc = function (a, b) {
  if (a.timestamp < b.timestamp) {
    return 1;
  }
  if (a.timestamp > b.timestamp) {
    return -1;
  }
  // a must be equal to b
  return 0;
};

/** add an end value for output */
export let addLastValue = (data) => {
  if (!data.length) {
    return data = [{
      timestamp: Date.now(),
      value: 0
    }, {
      timestamp: Date.now() - time.week,
      value: 0
    }];

  } 
  else {
    const newLast = {
      timestamp: Date.now(),
      value: null
    }
    
    const last = data[data.length - 1]
    const first = data[0]
    if (last.timestamp > first.timestamp) {
      newLast.value = last.value;
      data.push(newLast);
    }
    else {
      newLast.value = first.value;
      data.unshift(newLast);
    }

    return data;
  }
};
